import { render, staticRenderFns } from "./SliderSwitch.vue?vue&type=template&id=a2eb0c40&scoped=true&"
import script from "./SliderSwitch.vue?vue&type=script&lang=js&"
export * from "./SliderSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2eb0c40",
  null
  
)

export default component.exports